import React from 'react';
import { Table, Tooltip } from 'antd';
import { connect } from 'dva';

@connect(({ contactsList }) => ({
  ...contactsList,
}))
class TableList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }

  // 修改页面
  handleChangePagination = (page, callback) => {
    this.setState(
      {
        currentPage: page,
      },
      () => {
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
          callback();
        }
      }
    );
  };

  handleTableRowClick = deptInfo => {
    const { dispatch, expandedTreeNodeKeys } = this.props;
    const { deptId } = deptInfo;

    dispatch({
      type: 'contactsList/save',
      payload: {
        expandedTreeNodeKeys: [...expandedTreeNodeKeys, deptId],
        currentselectTreeNode: deptInfo,
        isRoot: 1,
        selectTreeNodeKey: [deptId],
        activeKey: 'dept',
      },
    });
    dispatch({
      type: 'contactsList/fetchDeptList',
      params: {
        deptId,
        pageIndex: 0,
        pageSize: 20,
      },
    });
  };

  intoSbuDept(data) {
    const { dispatch, nodeChain, expandedTreeNodeKeys } = this.props;
    expandedTreeNodeKeys.push(data.deptId);
    // console.log('push', expandedTreeNodeKeys)
    dispatch({
      type: 'contactsList/save',
      payload: {
        currentselectTreeNode: nodeChain[`__${data.deptId}`],
        isRoot: nodeChain[`__${data.deptId}`].isRoot,
        selectTreeNodeKey: [data.deptId],
        expandedTreeNodeKeys,
        activeKey: 'dept',
      },
    });
    dispatch({
      type: 'contactsList/fetchDeptList',
      params: {
        deptId: data.deptId,
        pageIndex: 0,
        pageSize: 20,
      },
    });
  }

  // 显示个人详细信息
  showPersonMsg(data) {
    const { dispatch } = this.props;
    dispatch({
      type: 'contactsList/save',
      payload: {
        showUserDetailsLayer: true,
      },
    });
    dispatch({
      type: 'contactsList/fetchUserDetails',
      userId: data.userId,
    });
  }

  renderTableList() {
    const { dataSource, columns = [], tabKey } = this.props;
    const { currentPage } = this.state;
    let data = []
    columns.map(item => {
      if (item.dataIndex !== 'followers') {
        data.push(item)
      }
    })
    data.forEach(ele => {
      const newEle = ele;
      const { dataIndex } = ele;
      if (dataIndex === 'deptName') {
        newEle.render = reocord => {
          // eslint-disable-next-line react/react-in-jsx-scope
          // return <div className="table-th-icon" onClick={() => this.intoSbuDept(text)} >{reocord}</div>;
          return (
            <Tooltip title={reocord} placement="topLeft">
              <div className="table-th-icon dept">{reocord}</div>
            </Tooltip>
          );
        };
      }
      if (dataIndex === 'userName') {
        newEle.render = (reocord, text) => {
          // eslint-disable-next-line react/react-in-jsx-scope
          // return <div className="table-th-icon" onClick={() => this.intoSbuDept(text)} >{reocord}</div>;
          return (
            <div className="table-th-icon user" onClick={() => this.showPersonMsg(text)}>
              {reocord}
            </div>
          );
        };
      }
    });
    const tableProps = {

      pagination: {
        pageSizeOptions: ['20', '50', '100', '200'],
        className: tabKey === 'dept' ? 'deptTable' : '',
        current: currentPage,
        defaultPageSize: 20,
        showSizeChanger: true,
        showQuickJumper: true,
        onChange: this.handleChangePagination,
        onShowSizeChange: () => this.handleChangePagination(1),
      },
      dataSource,
      // columns,
    };

    if (dataSource.length > 0) {
      tableProps.footer = () => (
        <div className="table-footer">{`共 ${dataSource.length} 条记录 第 ${currentPage} 页`}</div>
      );
    }
    if (tabKey === 'dept') {
      tableProps.onRow = record => ({ onClick: event => this.handleTableRowClick(record, event) });
    }
    return <Table {...tableProps} columns={data} />;
  }

  render() {
    return this.renderTableList();
  }
}

export default TableList;
